import { useBundleSpecial } from '@/hooks';
import { evaluate } from '@/utils';
import { Heading, useData } from '@/components';
import { ISpecial } from '@/types';
import styles from './specialbanner.module.scss';
import { PromoCarouselDocumentDataCarouselItemsItem } from 'prismicio-types';
import { asText } from '@prismicio/client';

interface ISpecialBanner {
  bundleId: string;
}

const SpecialBanner = ({ bundleId }: ISpecialBanner) => {
  const { promoCarousel } = useData();
  const { special: treezPreCartDiscount } = useBundleSpecial({ id: bundleId });

  const formatDiscount = (special?: ISpecial): ISpecial => {
    if (!special) return {} as ISpecial;

    // replace underscores with spaces in method field e.g. TARGET_PRICE -> TARGET PRICE
    return { ...special, method: special?.method?.replace(/_/g, ' ') };
  };

  if (!bundleId) return null;

  // find the discount item in the promo
  // carousel by title
  let cmsDiscountItem = promoCarousel?.carousel_items.find(
    (s: PromoCarouselDocumentDataCarouselItemsItem) =>
      s?.pos_title_name === treezPreCartDiscount?.posTitle,
  );

  // check if there is a default discount item
  if (!cmsDiscountItem) {
    cmsDiscountItem = promoCarousel?.carousel_items.find(
      (s: PromoCarouselDocumentDataCarouselItemsItem) =>
        s?.pos_title_name === 'default',
    );
  }

  const evaluateSpecial = evaluate(
    cmsDiscountItem,
    formatDiscount(treezPreCartDiscount),
  );
  const title = evaluateSpecial?.title ?? evaluateSpecial?.pos_title_name;
  const description = evaluateSpecial?.description?.length
    ? asText(evaluateSpecial.description)
    : treezPreCartDiscount?.description;

  return (
    <div className={styles.specialbanner}>
      <Heading className={styles.specialbanner__title} level={1}>
        {title}
      </Heading>
      <p>{description}</p>
    </div>
  );
};

export default SpecialBanner;
